import WarningPanelv2 from "../../lib/warning_panel/warning_panel_v2";
import React from "react";
import {
  CampaignItemStateAccepted,
  CampaignItemStateAwaitingAudio,
  ProductExchangeTypeInstructions,
} from "../../../constants/campaigns";

const ProductInstructionsInfo = ({ campaign, campaignItem, show }) => {
  const itemAccepted =
    campaignItem.state === CampaignItemStateAwaitingAudio ||
    campaignItem.state === CampaignItemStateAccepted;

  const isProductInstruction = campaign.productExchangeType === ProductExchangeTypeInstructions;
  if (!itemAccepted || !isProductInstruction) return null;

  return (
    <div className="m-bxxs">
      <WarningPanelv2>
        <div className="bold uppercase">Instructions for receiving product Samples</div>
        {campaign.productExchangeInstructions}
        {campaignItem.redemptionCodes?.length && (
          <>
            <div className="bold m-txs uppercase">Redemption Codes</div>
            <div>
              Enter this code at checkout (good for one use) to receive your product sample:
            </div>
            {campaignItem.redemptionCodes.map((code, i) => (
              <div className={"bold"} key={i}>
                {code}
              </div>
            ))}
          </>
        )}
      </WarningPanelv2>
    </div>
  );
};

export default ProductInstructionsInfo;
